import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import Integrate from "components/UnifiedProject/Integrate/Integrate";

import * as projectReducer from "containers/Project/reducer";
import * as helpReducer from "containers/Help/reducer";
import * as deploymentsReducer from "containers/Deployments/reducer";
import * as accountsReducer from "containers/Accounts/reducer";
import * as setupReducer from "containers/Setup/reducer";
import * as loginReducer from "containers/Login/reducer";

export const getRunId = (props) =>
  props && props.id
    ? props.id
    : props && props.match && props.match.params && props.match.params.runId
      ? props.match.params.runId
      : 2860;

class IntegrateContainer extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    const {} = this.props;

    return <Integrate {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const id = getRunId(ownProps);

  return {
    goToTableauHelp: () => dispatch(helpReducer.goToTableauIntegrationHelp()),
    goToSalesforceHelp: () => dispatch(helpReducer.goToSalesforceIntegrationHelp()),
    goToBoomiHelp: () => dispatch(helpReducer.goToBoomiIntegrationHelp()),
    scoreFile: (file, isMonitor = false) => dispatch(deploymentsReducer.scoreFile(id, file, isMonitor)),
    createDatasetFromMonitor: () => dispatch(deploymentsReducer.createDatasetFromMonitor(id)),
    setFrontierPercentProcessed: (value, useDefault) =>
      dispatch(setupReducer.setFrontierPercentProcessed(id, value, useDefault)),
    updateTerminalConditions: (terminalConditions) =>
      dispatch(projectReducer.updateTerminalConditions(id, terminalConditions)),
    updateActivityConditions: (activityConditions) =>
      dispatch(projectReducer.updateActivityConditions(id, activityConditions)),
    updateUniqueId: (uniqueId) => dispatch(projectReducer.updateUniqueIdName(id, uniqueId)),
    updateBusinessPredictionName: (businessPredictionName) =>
      dispatch(projectReducer.updateBusinessPredictionName(id, businessPredictionName)),
    handleUpdateMonitorSettings: () => dispatch(projectReducer.handleUpdateMonitorSettings(id))
  };
};

const mapStateToProps = (state, ownProps) => {
  //project id
  const id = getRunId(ownProps);
  //runid
  const selectedRunId = projectReducer.getRunId(state, id);
  const accountId = projectReducer.getProjectAccountId(state, id);

  return {
    deployment: deploymentsReducer.getProjectDeployment(state, id),
    isScoringFile: projectReducer.getIsScoringFile(state, id),
    accountAPIEndpoint: accountsReducer.getAccountAPIEndpoint(state, accountId),
    selectedDataset: setupReducer.getDatasetFromSetup(state, selectedRunId),
    uniqueId: projectReducer.getUniqueIdName(state, id),
    businessPredictionName: projectReducer.getBusinessPredictionName(state, id),
    terminalConditions: projectReducer.getTerminalConditions(state, id),
    activityConditions: projectReducer.getActivityConditions(state, id),
    isScenarioDeployed: projectReducer.getIsScenarioDeployed(state, id),
    isCurrentlyLoading: projectReducer.getIsLoading(state, id),
    selectedTenant: loginReducer.getSelectedTenant(state)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(IntegrateContainer);
